import React, { Suspense, lazy } from 'react';

const ReactDatePickerLazy = lazy(() => import('./DatePickerLazyComponent'));

const ReactDatePickerWrapper = React.forwardRef((props, ref) => {
  return (
    <Suspense fallback={<div className="react-datepicker-fallback"></div>}>
      <ReactDatePickerLazy ref={ref} {...props} />
    </Suspense>
  );
});

export default ReactDatePickerWrapper;
